<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.44397 0.558484C3.27994 0.644783 3.14168 0.786146 3.07015 0.940658C3.01251 1.06517 3.00476 1.17918 3.00409 1.9155L3.00331 2.74933L2.37758 2.76385C1.81209 2.777 1.72897 2.78709 1.51417 2.86855C0.851633 3.11991 0.370576 3.60096 0.119224 4.2635C0.0377556 4.4783 0.0276733 4.56142 0.014524 5.12691L0 5.75264H7.51565H15.0313L15.0168 5.12691C15.0036 4.56142 14.9936 4.4783 14.9121 4.2635C14.6595 3.59776 14.1829 3.12114 13.5171 2.86855C13.3023 2.78709 13.2192 2.777 12.6537 2.76385L12.028 2.74933V1.92318C12.028 1.25606 12.0175 1.0718 11.9732 0.965969C11.856 0.685182 11.5836 0.5 11.288 0.5C10.9769 0.5 10.7519 0.633678 10.6057 0.905405C10.535 1.03672 10.529 1.10508 10.5187 1.90129L10.5076 2.75617H7.51565H4.52373L4.51262 1.90129C4.50233 1.10508 4.49633 1.03672 4.42565 0.905405C4.3304 0.728402 4.21981 0.624371 4.05271 0.554571C3.88579 0.484806 3.58022 0.48678 3.44397 0.558484ZM0.0147708 10.5206L0.0244653 13.7726L0.116933 14.0103C0.37678 14.6782 0.84624 15.1477 1.51417 15.4075L1.75185 15.5H7.4804H13.209L13.4557 15.4218C14.1323 15.2074 14.6938 14.6526 14.9284 13.9665L15.0068 13.7374L15.0164 10.5029L15.0259 7.26851H7.51548H0.00507642L0.0147708 10.5206Z"
    />
  </svg>
</template>

<script>
export default {
  name: "CalendarIcon",
};
</script>

<style scoped></style>
